import { InferGetStaticPropsType } from 'next'

/* blocks */
import Layout from '@/cmp/templates/Layout/Layout'
import EventsPageTemplate from '@/cmp/templates/Events/EventsHomePage'

/* utils */
import { getStrapiGraphqlData } from '@/utils/api/wrapper'
import { TEN_MINS_REVALIDATION } from '@/utils/constants/revalidation'
import {
  EventsPageResponse,
  eventsHomepageQuery
} from '@/utils/queries/events-page'

function EventsPage({
  data,
  individualEventsPage
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const metadata = [
    {
      property: 'og:title',
      content: data.seo.title
    },
    {
      property: 'description',
      content: data.seo.description
    },
    {
      property: 'og:description',
      content: data.seo.description
    },
    {
      property: 'og:image',
      content: data.seo.featuredImage.data?.attributes.url
    }
  ]

  return (
    <Layout
      title="Pepper Content - Events"
      meta={metadata}
      canonical="/events/"
    >
      <EventsPageTemplate
        data={data}
        individualEventsPage={individualEventsPage}
      />
    </Layout>
  )
}

export const getStaticProps = async () => {
  const result = await getStrapiGraphqlData<EventsPageResponse>(
    eventsHomepageQuery.loc?.source.body
  )

  return {
    props: {
      data: result?.page?.data.attributes,
      individualEventsPage: result?.events?.data.map(i => i.attributes)
    },
    revalidate: TEN_MINS_REVALIDATION
  }
}

export default EventsPage
